export default __webpack_public_path__ + "static/media/pagar-comercios.e12fdc74.png";